import { Avatar } from "@material-ui/core";
import React, { useState } from "react";
import "../css/Comment.css";
import { useStateValue } from "../StateProvider";
import db from "../firebase";

import { Link } from "react-router-dom";

function Comment({ comments, postId }) {
  const [inputText, setInputText] = useState("");
  const [{ user, userProfile }] = useStateValue();

  const onSubmit = (e) => {
    e.preventDefault();
    var updateRef = db.collection("posts").doc(e.target.dataset.postid);

    if (!inputText) {
      console.log("is required");
    } else {
      updateRef
        .update({
          comments: [
            ...comments,
            {
              name: userProfile.name,
              text: inputText,
              profilePic: user.photoURL,
              username: userProfile.username,
              uid: userProfile.uid,
            },
          ],
        })
        .then(function () {
          console.log("Document successfully updated!");
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });
    }

    setInputText("");
  };

  return (
    <div className="comment">
      <div className="comment__datas">
        <ul>
          {comments.length > 0 &&
            comments.map((comment) => (
              <li key={comment.text}>
                <Avatar src={comment.profilePic && comment.profilePic} />
                <div className="comment__info">
                  <h3>
                    <Link to={`/profile/${comment.username}`}>
                      {comment.name}
                    </Link>
                  </h3>

                  <p>{comment.text}</p>
                </div>
              </li>
            ))}
        </ul>
      </div>

      <div className="comment__submit">
        <Avatar src={user.photoURL} />
        <form>
          <input
            placeholder="Write a comment..."
            type="text"
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
          />
          <button
            data-postid={postId}
            type="submit"
            onClick={onSubmit}
            className="comment__submit__button"
          >
            Post
          </button>
        </form>
      </div>
    </div>
  );
}

export default Comment;
